import React, { useState, useEffect } from 'react';

const About = () => {
  const [currentImage, setCurrentImage] = useState(0);
  
  // Replace these filenames with the actual images in your public/about-us folder
  const images = [
    "/about-us/image1.jpeg",
    "/about-us/image2.jpeg",
    "/about-us/image3.jpeg",
    "/about-us/image4.jpeg",
    "/about-us/image5.jpeg",
    "/about-us/image6.jpeg"
  ];

  // Auto-advance the slider every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <section id="about" className="py-20 bg-zinc-950 text-white border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="w-full md:w-1/2">
            <div className="relative h-96 w-full bg-zinc-800 border-2 border-gold/30 rounded overflow-hidden shadow-2xl">
              {images.map((img, index) => (
                <img 
                  key={index}
                  src={img}
                  alt={`About us showcase ${index + 1}`}
                  className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${
                    index === currentImage ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              ))}
              
              {/* Slider Navigation Dots */}
              <div className="absolute bottom-4 left-0 w-full flex justify-center space-x-3 z-10">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImage(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-colors duration-300 ${
                      index === currentImage ? 'bg-gold' : 'bg-white/40 hover:bg-white/80'
                    }`}
                    aria-label={`Go to image ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <h3 className="text-gold text-sm font-bold tracking-widest uppercase mb-2">About Us</h3>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif">Making Your Events <span className="text-gold">Memorable</span></h2>
            <p className="text-gray-400 mb-6 leading-relaxed">
              With years of experience in the event management industry, we bring creativity, passion, and meticulous attention to detail to every project. From conceptualization to execution, our dedicated team ensures a seamless and extraordinary experience for you and your guests.
            </p>
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div>
                <h4 className="text-3xl font-bold text-gold mb-1">500+</h4>
                <p className="text-sm text-gray-400">Events Completed</p>
              </div>
              <div>
                <h4 className="text-3xl font-bold text-gold mb-1">100%</h4>
                <p className="text-sm text-gray-400">Client Satisfaction</p>
              </div>
            </div>
            <a href="#contact" className="border border-gold text-gold px-6 py-3 hover:bg-gold hover:text-black transition duration-300 uppercase tracking-wider text-sm">
              Read More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;